// removed by extract-text-webpack-plugin
module.exports = {"close":"_1t4TD5QI2WOJ2CgIjRKS8k"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Dialog/style.scss
// module id = 947
// module chunks = 0